export default "__VITE_PUBLIC_ASSET__95aadec4__"